// src/features/authV2/ui/SocialButton.tsx

import { Button, Group } from "@mantine/core";

import { SocialProviderConfig } from "../config/config.tsx";

/**
 * @interface SocialButtonProps
 * @extends SocialProviderConfig
 * @description Пропсы для компонента SocialButton.
 * @property {function} onClick - Обработчик клика.
 * @property {boolean} loading - Состояние загрузки.
 */
interface SocialButtonProps extends SocialProviderConfig {
	onClick: (provider: SocialProviderConfig["provider"]) => void;
	loading: boolean;
}

/**
 * Компонент кнопки для входа через социальные сети.
 */
export const SocialButton = ({ provider, label, icon, onClick, loading, style }: SocialButtonProps) => (
	<Button
		fullWidth
		variant="default"
		size="md"
		onClick={() => onClick(provider)}
		loading={loading}
		loaderProps={{ type: "dots" }}
		style={style}
	>
		<Group gap="xs">
			{icon}
			{label}
		</Group>
	</Button>
);
